/**
 * Density strategy.
 */
function AdsNinjaDensityStrategyLeanBottom(){

    AdsNinjaDensityStrategy.call(this);
}

AdsNinjaDensityStrategyLeanBottom.prototype             = Object.create(AdsNinjaDensityStrategy.prototype);
AdsNinjaDensityStrategyLeanBottom.prototype.constructor = AdsNinjaDensityStrategyLeanBottom;

/**
 * @inheritdoc
 */
AdsNinjaDensityStrategyLeanBottom.prototype.determineDistanceBetweenZones = function(
    numberOfAdsLeftToInject, 
    relativeSpaceLeftToInjectAdsIn, 
    minimumPixelDistanceBetweenZones
){

    if(numberOfAdsLeftToInject <= 0){

        return null;
    }

    // Lean Bottom.
    return window.adsNinja.utils.roundUpToTwoDecimalPoints(Math.max(Math.floor(((relativeSpaceLeftToInjectAdsIn + minimumPixelDistanceBetweenZones) / (numberOfAdsLeftToInject + 1))), minimumPixelDistanceBetweenZones));
};

window.AdsNinjaDensityStrategyLeanBottom = AdsNinjaDensityStrategyLeanBottom;